<template>
  <v-footer color="secondary lighten-1" padless app>
    <v-row align="center" justify="center" no-gutters>
      <div class="mr-4 pr-4">
        <v-btn
          v-for="(link, i) in links"
          :key="i"
          class="ma-2"
          color="white"
          text
          link
          small
          :x-small="$vuetify.breakpoint.name === 'xs'"
          :to="link.link"
          @click="goTo(link.link)"
        >
          {{ $t(link.name) }}
        </v-btn>
      </div>
      <div class="text-center white--text text-overline ml-4 pl-4">
        ©{{ new Date().getFullYear() }} —
        <strong>Cetim. Tous droits réservés</strong>
      </div>
    </v-row>
  </v-footer>
</template>

<script>
import { monitore } from "./helpers/helpers";
export default {
  data: () => ({
    links: [
      { name: "navBar.tooltip.home", link: "/" },
      { name: "navBar.tooltip.about", link: "/about" },
      { name: "navBar.tooltip.contact", link: "/contact" },
    ],
  }),
  methods: {
    goTo(link) {
      monitore("Show page", link);
    },
  },
};
</script>